module.exports = __webpack_public_path__ + "img/h_bg.dbf04ec6.jpg";